module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Approvals")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet light portlet-fit bordered min-height-200"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorMessage),
      expression: "errorMessage"
    }],
    ref: "errorMessage",
    staticClass: "alert alert-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.clearError('errorMessage')
      }
    }
  })]), _vm._v(" "), _c('loading-screen', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('no-results', {
    attrs: {
      "show": _vm.noResults,
      "custom": true,
      "text": "There are no changes to review"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && !_vm.noResults && _vm.requests.length),
      expression: "!loading && !noResults && requests.length"
    }],
    staticClass: "row"
  }, [_c('div', {
    ref: "request",
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('tbody', _vm._l((_vm.request), function(field, index) {
    return _c('tr', {
      key: index,
      class: {
        'warning': field.existing !== field.modified
      }
    }, [_c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(field.label) + "\t\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(field.existing) + "\t\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('td', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(field.modified) + "\n\t\t\t\t\t\t\t\t\t")])])
  }))]), _vm._v(" "), _c('pagination', {
    attrs: {
      "passedPage": _vm.activePage,
      "numPages": _vm.total
    },
    on: {
      "activePageChange": _vm.activePageUpdate
    }
  }), _vm._v(" "), (_vm.$root.permissions['approvals update']) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.total !== _vm.activePage),
      expression: "total !== activePage"
    }],
    staticClass: "btn blue btn-outline margin-right-10",
    on: {
      "click": function($event) {
        _vm.skip(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tSkip\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger margin-right-10",
    on: {
      "click": function($event) {
        _vm.approveRequest(false)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tReject\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue",
    on: {
      "click": function($event) {
        _vm.approveRequest(true)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tApprove\n\t\t\t\t\t\t\t")])]) : _vm._e()], 1)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Approve or reject pending requests.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title bg-blue-chambray"
  }, [_c('div', {
    staticClass: "menu-image-main"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/client_logo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "caption-subject font-green bold uppercase"
  }, [_vm._v("Approval")]), _vm._v(" "), _c('div', {
    staticClass: "caption-desc font-grey-cascade"
  }, [_vm._v("Review and approve or reject the changes below.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("\n\t\t\t\t\t\t\t\t\tField\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v("\n\t\t\t\t\t\t\t\t\tCurrent\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('th', [_vm._v("\n\t\t\t\t\t\t\t\t\tAfter approval\n\t\t\t\t\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33d5a37f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/AdminManager/Approvals.vue
// module id = 695
// module chunks = 0